module.exports = __webpack_public_path__ + "media/image-testimonial02.eaa19715.png";